import { render } from "./promotion-modal.vue?vue&type=template&id=a22911e6"
import script from "./promotion-modal.vue?vue&type=script&lang=js"
export * from "./promotion-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__